import React from 'react'
import { Switch, Route, } from "react-router-dom";
import PoolViews from 'views/pool-views'

export const PoolLayout = () => {
	return (
		<div className="auth-container">
			<Switch>
				<Route path="" component={PoolViews} />
			</Switch>
		</div>

		
	)
}


export default PoolLayout
